import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

export const renderEquipment = ({
    schemaItem,
    item,
    columnKey,
    translate,
}: TableCellProps) => {
    const translationKey = `${columnKey}.label`;
    const translated = translate(translationKey);
    return (
        <td class={schemaItem.className} data-testid={columnKey}>
            {item[columnKey] && Number(item[columnKey]) !== 0
                ? item[columnKey] + " " + translated
                : "-"}
        </td>
    );
};
